export default {
  all: state => {
    return state.all
  },
  single: state => {
    return state.single
  },
  createFormData: state => {
    return state.createFormData
  },
  inlineEditingData: state => {
    return state.inlineEditingData
  }
}
